import Immutable from 'immutable';
import {
  SET_BRAINTREE_CLIENT_TOKEN,
  SET_PAYMENT_TRANSACTION,
  SUBMIT_PAYMENT_START,
  SUBMIT_PAYMENT_FAILURE,
  SET_PAYMENT_ERROR,
  ENTER_PAYMENTS_PAGE_DATA_LOAD_SUCCESS,
  PAYMENT_METHOD_SELECTED,
  ENTER_UPDATE_PAYMENT_METHOD_PAGE_DATA_LOAD_SUCCESS,
  UPDATE_PAYMENT_METHOD_START,
  UPDATE_PAYMENT_METHOD_FAILURE,
  ENTER_THANK_YOU_PAGE_DATA_LOAD_SUCCESS,
  SET_MOLPAY_PAYMENT_TRANSACTION,
  ENTER_PAYMENT_PAGE_DATA_LOAD_FAILURE,
} from './actions';
import {
  CREDIT_CARD,
  PAYPAL,
  MOLPAY,
  SUBSCRIPTION_PLAN,
  MYR,
  BRAINTREE,
  STRIPE,
} from './constants';

const initialState = Immutable.fromJS({
  paymentTransaction: null,
  braintreeClientToken: null,
  isProcessing: false,
  error: null,
  hasCouponCodes: false,
  paymentGateway: STRIPE,
  paymentMethod: CREDIT_CARD,
  paymentMethods: [CREDIT_CARD],
  molpayOptions: null,
  enterPaymentPageError: null,
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function PaymentTransaction(state = initialState, action = {}) {
  switch (action.type) {
    case ENTER_PAYMENTS_PAGE_DATA_LOAD_SUCCESS: {
      let newState = state;
      const {
        braintreeClientToken,
        stripePublishKey,
        paymentTransaction,
      } = action;
      const {
        currency,
        itemType,
        hasCouponCodes,
        paymentProcessor,
      } = paymentTransaction;

      newState = newState.merge(
        Immutable.fromJS({
          stripePublishKey,
          braintreeClientToken,
          paymentTransaction,
          hasCouponCodes,
        })
      );

      if (paymentProcessor !== STRIPE) {
        newState = newState.merge(
          Immutable.fromJS({
            paymentGateway: BRAINTREE,
            paymentMethod: CREDIT_CARD,
            paymentMethods: [CREDIT_CARD, PAYPAL],
          })
        );

        if (currency === MYR && itemType !== SUBSCRIPTION_PLAN) {
          newState = newState.merge(
            Immutable.fromJS({
              paymentMethod: MOLPAY,
              paymentMethods: [CREDIT_CARD, PAYPAL, MOLPAY],
            })
          );
        }
      }

      return newState;
    }
    case ENTER_UPDATE_PAYMENT_METHOD_PAGE_DATA_LOAD_SUCCESS: {
      const { braintreeClientToken, subscriptionId, subscriptionPlan } = action;
      return state.merge(
        Immutable.fromJS({
          paymentGateway: BRAINTREE,
          paymentMethod: CREDIT_CARD,
          paymentMethods: [CREDIT_CARD, PAYPAL],
          braintreeClientToken,
          subscriptionId,
          subscriptionPlan,
        })
      );
    }
    case ENTER_THANK_YOU_PAGE_DATA_LOAD_SUCCESS: {
      const { paymentTransaction } = action;
      return state.set(
        'paymentTransaction',
        Immutable.fromJS(paymentTransaction)
      );
    }
    case SET_BRAINTREE_CLIENT_TOKEN: {
      const { braintreeClientToken } = action;
      return state.set('braintreeClientToken', braintreeClientToken);
    }
    case SET_PAYMENT_TRANSACTION: {
      const { paymentTransaction } = action;
      return state.set(
        'paymentTransaction',
        Immutable.fromJS(paymentTransaction)
      );
    }
    case SET_MOLPAY_PAYMENT_TRANSACTION: {
      const { molpayOptions, paymentTransaction } = action;
      let newState = state;
      newState = newState.set(
        'paymentTransaction',
        Immutable.fromJS(paymentTransaction)
      );
      if (newState.get('isProcessing') || !molpayOptions) {
        return newState;
      }
      newState = newState.set('isProcessing', true);
      return newState.set('molpayOptions', Immutable.fromJS(molpayOptions));
    }
    case SUBMIT_PAYMENT_START:
    case UPDATE_PAYMENT_METHOD_START: {
      return state.set('isProcessing', true);
    }
    case SUBMIT_PAYMENT_FAILURE:
    case UPDATE_PAYMENT_METHOD_FAILURE: {
      const { error, paymentData } = action;
      const newState = state.set('isProcessing', false);
      return newState.set('error', {
        message: error,
        paymentData,
      });
    }
    case SET_PAYMENT_ERROR: {
      const { error } = action;
      return state.set('error', {
        message: error,
      });
    }
    case PAYMENT_METHOD_SELECTED: {
      const { paymentMethod } = action;
      if (state.get('isProcessing')) {
        return state;
      }
      return state.set('paymentMethod', paymentMethod);
    }
    case ENTER_PAYMENT_PAGE_DATA_LOAD_FAILURE: {
      const { message } = action;
      return state.set('enterPaymentPageError', message);
    }
    default: {
      return state;
    }
  }
}
